<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Remove from Matching</p>
        <button
          class="delete"
          aria-label="close"
          @click="closeModal">
        </button>
      </header>
      <section class="modal-card-body">
        <div class="modal-body">
          Are you sure you want to make a "No Match" decision for the record?
        </div>
        <div class="update-box">
          <a @click="closeModal">Cancel</a>
          <button
            class="button is-primary"
            @click="remove">
              Yes Select No Match
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ['stateStudentId'],
  methods: {
    remove() {
      this.$emit('removeStudent', this.stateStudentId);
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-card-title
    display: flex
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
